import React, { useState, useEffect } from "react";
import CommitOnBlurNumberInput from "../CommitOnBlurNumberInput";

function ValueInput(props) {
  const [tempValue, setTempValue] = useState("");

  useEffect(() => {
    setTempValue(String(Math.round(props.value)));
  }, [props.value]);

  const handleCommit = (value) => {
    setTempValue(String(Math.round(value)));
    if (typeof props.handleChange === "function") {
      props.handleChange(value);
    }
  };

  const handleCancel = () => {
    setTempValue(String(Math.round(props.value)));
  };

  return (
    <div className="StaticValueInputRow">
      <label className="StaticValueInputLabel" title={`${props.title}: ${props.tooltip}`}>
        {props.title}
      </label>
      <div className="StaticValueInputGroup">
        <CommitOnBlurNumberInput
          className="StaticValueInputField"
          wrapperClassName="InventumNumberInputControlFill"
          step={1}
          max={props.max}
          min={props.min}
          value={tempValue}
          onCommit={handleCommit}
          onCancel={handleCancel}
          onClick={(e) => e.stopPropagation()}
          title={props.tooltip}
        />
      </div>
    </div>
  );
}

export default ValueInput;
